import React from 'react';
import {Header, Breadcrumb, Icon, Label, Item,Segment,Container, Loader, Dropdown, Divider, Form, Dimmer, TextArea, Image, Table,  Button, Grid,Input, Radio, Message,MessageItem, MessageList, MessageHeader, List, Popup} from 'semantic-ui-react';
import { Link } from "react-router-dom";
import Content from '../NetflixSlider/ContentHeader';
import {moneda, stringToDate} from '../../util/index';
import Slider from '../NetflixSlider'; 
import Insignias from './Insignias';

import { PayPalScriptProvider } from "@paypal/react-paypal-js";
import PaypalCheckoutButton from "../common/PaypalCheckoutButton";

/*

<Segment placeholder>
                <Header icon>
                  <Icon name='warning sign'  color="red"/>
                  Tu acceso al curso de "Diplomado de inmunohematología 2022" fue suspendido hasta que finiquites tus pagos pendientes.
                </Header>
                <Button primary onClick={()=>showModalMetodosPago()}>Metodos de Pago</Button>
              </Segment>


    
                
                <Header as='h2' dividing >
                                Mis pagos Pendientes
        
                            </Header>
          
            

 <Grid verticalAlign="middle" divided='vertically'>
           <Grid.Row>
              <Grid.Column width={2}>
                <Icon name='warning sign' size="huge"  color="yellow"/>
              </Grid.Column>
              <Grid.Column width={5}>
        <Item.Group>
                 <Item>

                  <Item.Content>
                    <Item.Header>Taller de Planificación de Calidad Six Sigma</Item.Header>
                    <Item.Meta>
                      <span className='price'>Monto: $1,200</span>
                      <span className='stay'>Fecha Pago: 1 Abril 2022</span>
                    </Item.Meta>

                  </Item.Content>
                </Item>
         </Item.Group>
              </Grid.Column>
              <Grid.Column width={3}>
                <Button color="blue" onClick={()=>showModalMetodosPago()}>Metodos de Pago</Button>
              </Grid.Column>
            </Grid.Row>

<Grid.Row>
              <Grid.Column width={2}>
                <Icon name='warning sign' size="huge"  color="green"/>
              </Grid.Column>
              <Grid.Column width={5}>
        <Item.Group>
                 <Item>

                  <Item.Content>
                    <Item.Header>5to. Diplomado Internacional en Control de Calidad Analítica en el Laboratorio Clínico</Item.Header>
                    <Item.Meta>
                      <span className='price'>Monto: $1,900</span>
                      <span className='stay'>Fecha Pago: 15 Abril 2022</span>
                    </Item.Meta>

                  </Item.Content>
                </Item>
         </Item.Group>
              </Grid.Column>
              <Grid.Column width={3}>
                <Button color="blue" onClick={()=>showModalMetodosPago()}>Metodos de Pago</Button>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        
    ///////////////////////PAGOS//////////////////////////////////


  <Grid stackable>
                <Grid.Row >
                    <Grid.Column >    
                        <Header as='h2' dividing>
                           Pagos
                        </Header>
                    </Grid.Column>
                </Grid.Row>        
                 <Grid.Row >
                    <Grid.Column >         
                     {pagosLista.length>0?
    
                     <Table>
                            <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell>{strings?strings["fecha"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">{strings?strings["montoPago"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{strings?strings["seleccionar"]:""}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>



                            <Table.Body>

                              {pagosLista.map(pago =>


                                <Table.Row>
              

                                <Table.Cell textAlign="right">{stringToDate(pago.fechaPago)}</Table.Cell>


                                <Table.Cell textAlign="right">{moneda(pago.montoPago)}</Table.Cell>
                                
                                <Table.Cell textAlign="center">
                                    {pago.pagado==0?
                                        <Radio
                                            label={pago.id}
                                            name='radioGroup'
                                            value={pago.id}
                                            checked={pagoLiquidar.id === pago.id}
                                            onChange={()=>handleChangePago(pago.id)}
                                          />
                                     
                                    :
                                        "Pagado"
                                    }
                                </Table.Cell>
                                </Table.Row>

                            )}

                            </Table.Body>



                        </Table>

                    :

                            ""
                            
            }    
                </Grid.Column>
            </Grid.Row>          
            <Grid.Row >
                <Grid.Column textAlign="center">    
                {cursoPago.descripcion!=null?
                <PayPalScriptProvider options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
                    <div className="paypal-button-container">
                         <PaypalCheckoutButton curso={cursoPago} handleApprove={handleApprove} />
                    </div>
                </PayPalScriptProvider>
                :
                    "Selecciona un pago"
                }    
                </Grid.Column>
            </Grid.Row>                 
                        
                
                </Grid>         

   
            <Message color='blue'
            size='mini'
            icon='info circle'
            header={strings?strings["aviso"]:""}
            content={strings?strings["avisoUsuario"]:""}
               />
    
                

*/


///////////////SECCION CAMBIO DE LUGAR (PAGOS)

/*
           
           <Grid stackable>
                <Grid.Row >
                    <Grid.Column >    
                        <Header as='h2' dividing>
                            {pagosLista.length>0?    
                                <p>{strings?strings["Pagos"]:""}</p>
                             :
                                <p>{strings?strings["SinPagosPendientes"]:""}</p>
                            }
                        </Header>
                    </Grid.Column>
                </Grid.Row>        
                 <Grid.Row >
                    <Grid.Column >         
                     {pagosLista.length>0?
    
                     <Table>
                            <Table.Header>
                                <Table.Row>
                                <Table.HeaderCell>{strings?strings["FormaPago"]:""}</Table.HeaderCell>
                                <Table.HeaderCell>{strings?strings["Curso"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">{strings?strings["FechaLimite"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="right">{strings?strings["Monto"]:""}</Table.HeaderCell>
                                <Table.HeaderCell textAlign="center">{strings?strings["Seleccionar"]:""}</Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>



                            <Table.Body>

                              {pagosLista.map(pago =>


                                <Table.Row>
              
                                <Table.Cell >PayPal</Table.Cell>    
                                <Table.Cell >{pago.curso}</Table.Cell>
                               
                                <Table.Cell textAlign="right">{stringToDate(pago.fechaPago2)}</Table.Cell>


                                <Table.Cell textAlign="right">{moneda(pago.montoPago)}</Table.Cell>
                                
                                <Table.Cell textAlign="center">
                                    {pago.pagado==0?
                                        <Radio
                                            label="Seleccióna pago"
                                            name='radioGroup'
                                            value={pago.id}
                                            checked={pagoLiquidar.id === pago.id}
                                            onChange={()=>handleChangePago(pago.id)}
                                          />
                                     
                                    :
                                        <>{strings?strings["Pagado"]:""}</>
                                    }
                                </Table.Cell>
                                </Table.Row>

                            )}

                            
                            
                            {pagosLista.map(pago =>


                                <Table.Row>
                                    <Table.Cell>Depósito<br/> 
                                
                                    </Table.Cell>    
                               <Table.Cell >{pago.curso}</Table.Cell>
                               
                                <Table.Cell textAlign="right">{stringToDate(pago.fechaPago2)}</Table.Cell>


                                <Table.Cell textAlign="right">{moneda(pago.montoPago)}</Table.Cell>
                                
                                <Table.Cell textAlign="center">
                                    <Button color="blue" onClick={()=>onShowDeposito()}>Depósito</Button>
                                </Table.Cell>
                                </Table.Row>

                            )}

                            {showDeposito>0?
                                <Table.Row >
                                    <Table.Cell colSpan="5">
                                
                                
                                        <Message size='large' color='blue'>
                                           
                                           
                                            <MessageHeader>Datos de depósito</MessageHeader>
                                                <br/>
                                                <p><b>Si el pago lo quieres realizar por transferencia bancaria tu pago en la siguiente cuenta:</b></p>
                                                <MessageList>
                                                  <MessageItem>QUIALIS INTERNATIONAL LLC</MessageItem>
                                                  <MessageItem>BANCO: BANK OF AMERICA</MessageItem>
                                                  <MessageItem>CUENTA: 8 9 8 1 1 8 8 3 9 1 9 7</MessageItem>
                                                  <MessageItem>(ROUTING): 0 6 3 0 0 0 0 4 7</MessageItem>
                                                  <MessageItem>ABA: 0 2 6 0 0 9 5 9 3</MessageItem>
                                                  <MessageItem>SWIFT: BOFAUS3N</MessageItem>
                                                  <MessageItem>CIUDAD: DORAL, FLORIDA, USA</MessageItem>
                                                  <MessageItem>SUCURSAL: DORAL PLAZA BANKING CENTER</MessageItem>
                                                </MessageList>
                                                
                                                <p>Esta transaccion será verificada en un plazo de 72 horas  </p>
                                            
                                          </Message>
                                        
                                        <Message size='large' color='blue'>
                                           
                                           
                                            <MessageHeader>¿Necesitas factura?</MessageHeader>
                                            <br/>
                                                <MessageList>
                                                  <p><b>Solicitala al siguiente correo atencion_academica@qsc.com.mx y envia los siguientes datos</b></p>
                                                  <MessageItem>Nombre o razón social</MessageItem>
                                                  <MessageItem>Identificación (despliega opciones Cedula, INE; NIT, RUT; RFC, ETC)</MessageItem>
                                                  <MessageItem>Dirección</MessageItem>
                                                  <MessageItem>Código postal</MessageItem>
                                                  <MessageItem>Ciudad o municipio</MessageItem>
                                                  <MessageItem>País</MessageItem>
                                                  <MessageItem>Correo</MessageItem>
                                                    <p> Si el pago lo realiza una entidad, anexar copia del  RUT/ CONSTANCIA DE SITUACIÓN FISCAL  (enviar el archivo jpg o un pdf)<br/> La factura la recibirás en tu correo en 5 días hábiles, luego de verificar tu pago.</p>
                                                </MessageList>
                                           
                                            
                                          </Message>
                                                
                            
                                    </Table.Cell>    
                             
                                </Table.Row>
                            :""}

                            </Table.Body>



                        </Table>

                    :

                            ""
                            
            }    
                </Grid.Column>
            </Grid.Row>
            {pagosLista.length>0?    
            <Grid.Row >
                <Grid.Column textAlign="center">    
                {cursoPago.descripcion!=null?
                <PayPalScriptProvider options={{"client-id":process.env.REACT_APP_PAYPAL_CLIENT_ID,"currency":"USD", "locale":"es_MX"}}>
                    <div className="paypal-button-container">
                         <PaypalCheckoutButton curso={cursoPago} handleApprove={handleApprove} />
                    </div>
                </PayPalScriptProvider>
                :
                    <>{strings?strings["SeleccionaPago"]:""}</>
                }    
                </Grid.Column>
            </Grid.Row>                 
                        
            :
                ""
            }
            
          

        </Grid>     
           */

const Miespacio=({ id, color, userInfo, pagos=[], showModalMetodosPago, cursosActuales,cursosPrevios,  form, onSave,onChange, ajaxCallInProgress, datos, errors={}, strings, permisos, constancias, pagosLista, handleApprove, pagoLiquidar, handleChangePago, cursoPago,showDeposito,onShowDeposito, showModalComentario})=>{
    
    
	return (
        <Container >
        <Dimmer.Dimmable   dimmed={ajaxCallInProgress>0?true:false}>
        <Segment basic>
        
        
        
        <Grid stackable>
         <Grid.Row>
                <Grid.Column>
                    <Header  as='h2'   dividing > 
                        <Header.Content>{strings?strings["MiEspacio"]:""}
                        </Header.Content>
                    </Header>
                </Grid.Column>    
        </Grid.Row>    
            {pagosLista.length>0?
            <Grid.Row>
                <Grid.Column width={13} textAlign="right">
                    <Header.Content>{strings?strings["cursoPendiente"]:""}</Header.Content>
                </Grid.Column>
                <Grid.Column width={1} textAlign="right">
                    <Link to="/pagolinea">
                        <Button    animated='fade'>
                            <Button.Content visible>{strings?strings["pagarCurso"]:""}</Button.Content>
                            <Button.Content hidden > <Icon name='shopping cart' /> </Button.Content>
                        </Button>
                    </Link>     
                </Grid.Column>
            </Grid.Row>
                :""}
      </Grid>

        
        
            {cursosActuales.length>0?
                <Grid stackable>
                    <Grid.Row only='computer tablet'>
                        <Grid.Column>
                            <Header as='h2' dividing >
                                {strings?strings["ContinuarCursos"]:""}
                            </Header>
                            <div className="app" style={{backgroundColor: '#000000'}}> 
                                <div>
                                 <Slider>
                                  {cursosActuales.map(movie => (
                                    <Slider.Item movie={movie}   key={movie.id}>item1</Slider.Item>
                                  ))}
                                </Slider>
                                </div>
                            </div>
                        </Grid.Column>        
                    </Grid.Row>
                    <Grid.Row only='mobile' >
                        <Grid.Column >    
                            <Header as='h2' dividing>
                                {strings?strings["ContinuarCursos"]:""}
                            </Header>

                            {cursosActuales.map(movie => (

                                    <Image src={movie.image} fluid as='a'  href={movie.url}  />
                                
                            ))}
                        </Grid.Column>    
                    </Grid.Row>        
                    
                    {constancias.length>0?
                      <Grid.Row only='computer tablet'>
                            <Grid.Column >    
                                <Header as='h2' dividing>
                                    {strings?strings["MisConstancias"]:""}
                                </Header>
                   
                                <Grid columns={3} padded>
                                       
                                 {constancias.map(constancia => (
                                   <Grid.Row >
                                    <Grid.Column> 
                                        <a href={"/api/inscripcion/reconocimiento?id="+constancia.idCurso}  target="_black" 
                                            color="green" attached='bottom'>
                                            &nbsp;{constancia.curso}</a>
                                    </Grid.Column >   
                                    <Grid.Column textAlign ="right">
                                        {constancia.comentario!=null && constancia.comentario>0?
                                            <>
                                
                                            {constancia.estatusComentario==1 || constancia.estatusComentario==2 || constancia.estatusComentario==3?
                                                <>Visualizar comentario</>
                                            :
                                                <>Editar o visualizar comentario</>
                                            }
                                
                                
                                            </>
                                        :
                                            <>
                                            Agregar comentario:
                                            </>
                                        }
                                    </Grid.Column >   
                                    <Grid.Column textAlign ="left">
                                        <List horizontal>
                                            <List.Item>
                                                {constancia.comentario!=null && constancia.comentario>0?
                                                 <Popup
                                                    trigger={<Icon  name='eye' link   
                                                     onClick={()=>showModalComentario(constancia.idCurso, constancia.comentario)}          
                                                    size="large"  color="tela" ></Icon>}
                                                    content='Visualizar'

                                                  />
                                                 :
                                                    <Popup
                                                    trigger={<Icon  name='edit outline' link   
                                                     onClick={()=>showModalComentario(constancia.idCurso, constancia.comentario)}          
                                                    size="large"  color="tela" ></Icon>}
                                                    content='Agregar'

                                                  />                    

                                                }
                                            </List.Item>
                                        </List>
                                    </Grid.Column >
                                </Grid.Row >            
              
                            ))}
                            </Grid>    
                                
                        </Grid.Column>    
                            
                    </Grid.Row>
                    :
                    ""
                    }
                </Grid>         
            :
                <Header as='h2' dividing>
                    {strings?strings["NoInscrito"]:""}
                </Header>
            }
          
            
           
           

       
               <Divider hidden/>
           
                

            
          {cursosPrevios.length>0? 
                <div>
                    <Header as='h2' dividing>
                        {strings?strings["OtrosProgramas"]:""}
                    </Header>
                    
                    <Divider hidden/>
                        <Table  celled inverted selectable >
                            <Table.Body>    
                                    {cursosPrevios.map(previo => (
                                        <Table.Row>          
                                            <Table.Cell >
                                                <Label as='a' color='teal' ribbon>
                                                    {strings?strings["Curso"]:""}: {previo.nombreCurso}
                                                </Label>
                                                <br/>
                                                <br/>        
                                                 <Label as='a' color='teal' ribbon>
                                                    {strings?strings["Fecha"]:""}: {previo.fechaCurso}
                                                </Label>
                                                
                                            </Table.Cell>
                                            <Table.Cell textAlign="center"><Image src={previo.constanciaImg}/></Table.Cell>
                                        </Table.Row>   

                                    ))}
                             </Table.Body>
                        </Table> 
                    
                </div>
           :""  }
           
           

         <Dimmer active={ajaxCallInProgress>0?true:false} inverted>
          		<Loader size='big'  content={strings?strings["Procesando"]:""}/>
          </Dimmer>
        
        </Segment>
        </Dimmer.Dimmable>
        </Container>
	);
};



export default Miespacio;